import React from 'react'
import { Button, Dropdown } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { supportedChainIds } from '../../constants'
import { useWeb3Context } from '../../context/'
import { chianToName } from '../../hooks/globalHelpers'
import { switchNetwork } from '../../hooks/Web3CustomHooks'

const ConnectButton = ({ connect, error }) => {
  const navigate = useNavigate();
  
  return connect ? (
    (error === "Network" ?
      <Dropdown>
        <Dropdown.Toggle variant="warning" className='main-btn' id="dropdown-basic">
          Switch Chain
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {supportedChainIds.map((chainId, index) => {
            return <Dropdown.Item key={index} onClick={async () => {
              await switchNetwork(chainId);
              connect();
            }}>{chianToName(chainId)}</Dropdown.Item>
          })
          }
        </Dropdown.Menu>
      </Dropdown>
      :
      <Dropdown>
        <Dropdown.Toggle variant="primary" className='main-btn' id="connect-dropdown">
          Connect Wallet
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={connect}>
            <i className="fas fa-link me-2"></i>
            Connect DBN From BSC
          </Dropdown.Item>
          <Dropdown.Item onClick={() => navigate('/solana')}>
            <i className="fab fa-solana me-2"></i>
            Connect DBN From SOL
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    )
  ) : (
    <button>Loading...</button>
  )
}
const DisconnectButton = ({ disconnect }) => {
  return disconnect ? (
    <div onClick={disconnect} className='buttons'>
    <button className='btn main-btn'>Disconnect</button>
  </div>
  ) : (
    <button>Loading...</button>
  )
}

export function Web3Button() {
  const { web3Provider, connect, disconnect, error } = useWeb3Context()

  return web3Provider ? (
    <DisconnectButton disconnect={disconnect} />
  ) : (
    <ConnectButton connect={connect} error={error} />
  )
}
